import React, { useMemo } from "react";

import { useTimeSettings } from "lib/api";
import { getFormattedDateTimeWithTZ } from "lib/utils/datetime";

import OverflowTooltip from "../../../OverflowTooltip";

interface DateColumnCellProps {
  date: string;
}

// due to spacing calculation and to display the overflow tooltip correctly,
// please make sure you have padding 0 in the column
const DateColumnCell: React.FC<DateColumnCellProps> = ({ date }) => {
  const { timezone } = useTimeSettings();

  const formattedDate = useMemo(() => {
    if (date) return getFormattedDateTimeWithTZ(date, timezone);
    return "—";
  }, [date, timezone]);

  return <OverflowTooltip data={formattedDate as string} />;
};

export default DateColumnCell;
